import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { graphql, compose } from 'react-apollo';
import { sortBy } from 'lodash';
import { relatedQuestions as relatedQuestionsQuery } from 'legacy/src/queries';
import './RelatedQuestions.scss';
import { getPriorStudentsSubdir } from 'legacy/src/utility/utils';

/**
 * Get all related question by subunit and skills
 * that are in the same assignment
 **/
const RelatedQuestions = ({
  studentContext,
  questions = [],
  params,
  routes,
  isYourResult,
  questionsOrder = [],
  isPPC,
}) => {
  const buildQuestionPath = (relatedQuestionId) => {
    const studentTeacherPath = isYourResult ? 'performance' : 'questions';

    const { subject, assignmentId, ppcPartId } = params;
    const { hasContext, questionsPath } = studentContext;

    let url;
    if (hasContext && ppcPartId) {
      url = questionsPath
        .replace(':assignmentId', assignmentId)
        .replace(':partId', ppcPartId);
      url += `${isPPC ? 'performance' : 'questions'}/${relatedQuestionId}`;
    } else {
      url = `/${subject}/assessments/results/${assignmentId}${getPriorStudentsSubdir(
        routes,
      )}/${studentTeacherPath}/${relatedQuestionId}`;
    }
    return url;
  };

  //Discard questions without valid QuestionId
  let filteredQuestions = questions.filter(
    (question) => question.questionId !== undefined,
  );
  if (filteredQuestions.length === 0) {
    return null;
  }

  if (questionsOrder.length > 0) {
    filteredQuestions = filteredQuestions.map((question) => ({
      ...question,
      finalIndex: questionsOrder.findIndex(
        (orderedQuestion) =>
          String(orderedQuestion) === String(question.questionId),
      ),
    }));
  }

  const questionElements = sortBy(filteredQuestions, ['finalIndex']).map(
    (q) => {
      const { questionId, index, finalIndex = index } = q;
      return (
        <Link
          data-test-related-question={questionId}
          to={buildQuestionPath(questionId)}
          className="question"
          key={`question-${index}`}
        >
          Question {finalIndex + 1}{' '}
          {/* backend send zero indexing for question positions */}
        </Link>
      );
    },
  );

  const showHeader = questionElements && questionElements.length > 0;
  return (
    <div className="RelatedQuestions" data-test-related-questions>
      {showHeader && (
        <div className="header"> Related Questions on this Quiz </div>
      )}
      {questionElements}
    </div>
  );
};

RelatedQuestions.displayName = 'RelatedQuestions';

RelatedQuestions.propTypes = {
  /**
   * Student context
   * */
  studentContext: PropTypes.shape({
    hasContext: PropTypes.bool,
    studentId: PropTypes.string,
    resultsPath: PropTypes.string,
    progressPath: PropTypes.string,
    questionsPath: PropTypes.string,
  }),
};

RelatedQuestions.defaultProps = {
  studentContext: {
    hasContext: false,
    studentId: null,
    resultsPath: '',
    progressPath: '',
    questionsPath: '',
  },
};

const getRelatedQuestions = graphql(relatedQuestionsQuery, {
  options: ({ params }) => {
    const { assignmentId, ppcPartId, questionId } = params;
    return {
      variables: {
        assignmentId: ppcPartId || assignmentId,
        questionId,
      },
    };
  },
  props: ({ data: { relatedQuestions, error } }) => {
    if (error) {
      return {
        error: error.message,
      };
    }

    if (relatedQuestions) {
      const { questions } = relatedQuestions;
      return {
        questions,
      };
    }
  },
});
export default compose(getRelatedQuestions)(RelatedQuestions);
